var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import * as React from 'react';
import omit from 'lodash/omit';

import BaseSelectField from './BaseSelectField';

var SingleSelectField = function (_React$Component) {
    _inherits(SingleSelectField, _React$Component);

    function SingleSelectField() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, SingleSelectField);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SingleSelectField.__proto__ || Object.getPrototypeOf(SingleSelectField)).call.apply(_ref, [this].concat(args))), _this), _this.handleChange = function (selectedOptions) {
            var _this$props = _this.props,
                onChange = _this$props.onChange,
                fieldType = _this$props.fieldType;

            // There should only ever be 1 selected item

            if (onChange && selectedOptions.length === 1) {
                onChange(selectedOptions[0], fieldType);
            }
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(SingleSelectField, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                isDisabled = _props.isDisabled,
                selectedValue = _props.selectedValue,
                placeholder = _props.placeholder,
                rest = _objectWithoutProperties(_props, ['isDisabled', 'selectedValue', 'placeholder']);

            // @TODO(jtan): Invariant testing
            // 1) selectedValue is required to be contained in the options
            // 2) # of options should be non-zero

            // Make sure to omit passed props that could be interpreted incorrectly by the base component


            var selectFieldProps = omit(rest, ['defaultValue', 'multiple', 'onChange']);

            // If selectedValue is passed in, map it to the multi selected equivalent
            var isFieldSelected = selectedValue !== null;
            selectFieldProps.selectedValues = !isFieldSelected ? [] : [selectedValue];

            return React.createElement(BaseSelectField, _extends({
                isDisabled: isDisabled,
                onChange: this.handleChange,
                placeholder: placeholder,
                className: !isFieldSelected && placeholder ? 'placeholder' : ''
            }, selectFieldProps));
        }
    }]);

    return SingleSelectField;
}(React.Component);

SingleSelectField.propTypes = {
    /** The type of the field */
    fieldType: PropTypes.string,

    /** The select field is disabled if true */
    isDisabled: PropTypes.bool,

    /** The currently selected option value */
    selectedValue: function selectedValue() {
        return (typeof bpfrpt_proptype_SelectOptionValueProp === 'function' ? bpfrpt_proptype_SelectOptionValueProp : PropTypes.shape(bpfrpt_proptype_SelectOptionValueProp)).apply(this, arguments);
    },

    /** The placeholder text for the field  */
    placeholder: PropTypes.string,

    /** Function will be called with the selected option after user selects a new option */
    onChange: PropTypes.func.isRequired
};


export default SingleSelectField;
import { bpfrpt_proptype_SelectOptionValueProp } from './props';
import { bpfrpt_proptype_SelectOptionProp } from './props';
import PropTypes from 'prop-types';